// Partner integration snippet — the HTML DriveCars hands partners to embed
// the widget on their own site. Two callers built this near-identically and
// drifted: apps/backoffice's admin screen emitted capitalised component tags
// (`<drivecars-Search>`) that the widget loader's lowercase tag->bundle map
// never matches, so the custom element renders empty with no error; both
// callers also hard-coded their own loader host. One builder, lowercase
// tags always, loader host passed in by the caller (each app reads its own
// env var — this helper stays framework-agnostic).

export interface BuildEmbedSnippetInput {
  /** URL of the widget loader script. */
  loaderUrl: string;
  /** Base URL the widget's custom elements call for data. */
  apiBase: string;
  /** Component names to embed, e.g. ['search', 'checkout']. Case-insensitive
   *  — every tag is lowercased since the loader's tag->bundle map is keyed
   *  lowercase. */
  components: string[];
  /** Placeholder text for the session-token attribute, shown to the partner
   *  as something to substitute with a real token. Defaults to
   *  'YOUR_SESSION_TOKEN'. */
  tokenPlaceholder?: string;
}

/** Build the `<script>` + `<drivecars-*>` embed snippet handed to partners. */
export function buildEmbedSnippet({
  loaderUrl,
  apiBase,
  components,
  tokenPlaceholder = 'YOUR_SESSION_TOKEN',
}: BuildEmbedSnippetInput): string {
  return [
    `<script src="${loaderUrl}"></script>`,
    ...components.map((component) => {
      const tag = component.toLowerCase();
      return `<drivecars-${tag} base-url="${apiBase}" token="${tokenPlaceholder}"></drivecars-${tag}>`;
    }),
  ].join('\n');
}
